export default "__VITE_ASSET__657f7b74__"